import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import { OrderChat } from '@rio-cloud/rio-order-chat-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import { DefaultUserMenu, EulaConsent } from '@rio-cloud/rio-user-menu-component';
import IframeResizer from 'iframe-resizer-react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink, useLocation } from 'react-router';

import { config } from '../config';
import { getUserTenant } from '../configuration';
import { useMaintenanceModeEnabled } from '../configuration/featureToggle/hooks/useMaintenanceModeEnabled';
import { type RootState, useAppSelector } from '../configuration/setup/store';
import { getCustomerCenterPath } from './app/common/routes';
import {
    getMainNavigationCustomerCenterTabs,
    isSubTabOfTabActive,
} from './app/customerCenter/customerCenterTabService';
import type { TabInfo } from './app/customerCenter/types';
import { InformationActionBarItem } from './InformationActionBarItem';

interface AppHeaderProps {
    availableTabs: TabInfo[];
}

function customerCenterTabs(tabs: TabInfo[], pathName: string) {
    return tabs.map(tab => {
        const isParentOfActiveSubTab = isSubTabOfTabActive(tab.componentName, pathName);
        return {
            key: tab.componentName,
            route: (
                <NavLink
                    to={getCustomerCenterPath(tab.componentName)}
                    className={isParentOfActiveSubTab ? 'active' : undefined}
                >
                    <FormattedMessage id={tab.labelId} />
                </NavLink>
            ),
        };
    });
}

export function AppHeader(props: AppHeaderProps) {
    const { pathname } = useLocation();

    const maintenanceMode = useMaintenanceModeEnabled();
    const tenant = useAppSelector(getUserTenant) || 'unknown';
    const availableTabs = maintenanceMode ? [] : props.availableTabs;

    const environment = import.meta.env.PROD ? 'production' : 'local';
    const appTitle = <FormattedMessage id={'marketplace.customerCenter'} />;

    const menuUrl = config.backend.MENU_SERVICE as string;

    const appNavigator = <IframeResizer className='iFrameResizer' src={menuUrl} />;

    const homeLink = <a href={config.homeRoute} />;

    return (
        <ApplicationLayout.Header>
            <ApplicationHeader
                label={appTitle}
                appNavigator={appNavigator}
                homeRoute={homeLink}
                navItems={customerCenterTabs(availableTabs, pathname)}
                actionBarItems={[
                    <InformationActionBarItem key={'information'} />,
                    <OrderChat tenant={tenant} key={'chat'} />,
                    <RioNotifications key={'notifications'} />,
                    <DefaultUserMenu environment={process.env.NODE_ENV as string} key={'menu'} />,
                ]}
            />
            <EulaConsent environment={environment} />
        </ApplicationLayout.Header>
    );
}

export const mapStateToProps = (state: RootState) => ({
    availableTabs: getMainNavigationCustomerCenterTabs(state),
});

export const AppHeaderContainer = connect(mapStateToProps)(AppHeader);
